import{SELECT_LOCATION}from"../constants";/**
 * Creates the dispatched SELECT_LOCATION action object.
 * @param {Object} location The location data to store for the use.
 * @returns {Object}
 */var selectLocation=function selectLocation(location){return{type:SELECT_LOCATION,location:location};};export default selectLocation;